module.exports = __webpack_public_path__ + "static/media/eyeIcon.a0f82d98.svg";